import FlexiText from "slotworks/graphics/elements/flexi-text";
import Layers from "slotworks/graphics/layers/layers";
import BitmapText from "slotworks/graphics/pixi/bitmap-text";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AbstractTextControl extends AbstractControl implements Control {

    protected text: FlexiText | BitmapText;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
        this.text = layer.getFlexiText(assetName);
        if (!this.text) {
            this.text = layer.getBitmapText(assetName);
        }
    }

    public setVisible(visible: boolean) {
        this.text.setVisible(visible);
    }

    public destroy() {
        this.text.destroy();
    }
}
